import { render, staticRenderFns } from "./Layout93.vue?vue&type=template&id=12712d1d"
import script from "./Layout93.vue?vue&type=script&lang=js"
export * from "./Layout93.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports